export const styles = {
    container: "min-h-screen flex items-center justify-center",
    card: "max-w-4xl w-full mx-auto p-8 bg-background rounded-lg shadow-lg",
    heading: "text-3xl font-semibold text-primary custom-font",
    button: {
        base: "w-full lg:w-auto px-6 py-3 rounded-lg transition-colors",
        primary: "bg-accent hover:bg-accent-dark text-white",
        disabled: "bg-gray-400 cursor-not-allowed",
    },
    input: {
        base: "block w-full p-3 border border-text-primary rounded-md shadow-sm",
        focus: "focus:outline-none focus:ring-2 focus:ring-accent focus:border-accent"
    },
    modal: {
        overlay: "fixed inset-0 bg-gray-600 bg-opacity-50 flex justify-center items-center z-50",
        content: "bg-white p-6 rounded shadow-lg w-full max-w-4xl mx-4 h-auto max-h-[90vh] overflow-y-auto"
    },
    conceptSelector: {
        container: "flex flex-wrap gap-4",
        option: "border p-4 w-32 rounded-lg cursor-pointer flex items-center justify-center text-center",
        selected: "border-2 border-accent",
        unselected: "border-gray-300"
    }
};